import {EventEmitter, Injectable} from "@angular/core";

@Injectable(
    {
        providedIn: 'root',
    }
)
export class CargandoService {
    private _cargandoEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();

    habilitarCargando() {
        this._cargandoEmitter.emit(true);
    }

    deshabilitarCargando() {
        this._cargandoEmitter.emit(false);
    }

    get cargando$() {
        return this._cargandoEmitter;
    }

}
